import React from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../../store';
import { setPage } from '../../../store/features/moments/momentsSlice';
import CreateMomentForm from './createMomentForm';

const CreateMoment = () => {
    const dispatch = useDispatch();
    const { words} = useAppSelector(state => state.localization);
    const { page } = useAppSelector(state => state.moments);
    const handleClick = e => {
        e.preventDefault(),
         dispatch(setPage({...page, name: 'momentsHome' }));
    };

    return (
        <div className="create-moment">
            <div className="micro-content-01">
                <button className="c-item-01" onClick={e => handleClick(e)}>
                    <svg className="close-icon" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
                            stroke="#6C6C7D"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M21.875 13.125L13.125 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.125 13.125L21.875 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                <h2 className="c-item-02">{words && words['WEB.createMomentPlural']}</h2>
                <p className="c-item-03">{words && words['WEB.createMomentText']}</p>
            </div>
            <div className="section-06">
                <CreateMomentForm />
            </div>
        </div>
    );
};

export default CreateMoment;
